var render = function render(){
  var _vm$form$documents;
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "vendor-form.documents mt-4"
  }, [_c('div', {
    staticClass: "d-flex justify-content-end mb-3"
  }, [!_vm.hasAnyRowEditing ? [!_vm.isDetail ? _c('b-button', {
    staticClass: "mr-2",
    attrs: {
      "variant": "danger",
      "size": "sm",
      "disabled": !_vm.rowIndexSelecteds.length
    },
    on: {
      "click": _vm.deleteSelected
    }
  }, [_c('i', {
    staticClass: "fas fa-trash-alt"
  }), _vm._v(" Delete Selected ")]) : _vm._e(), _c('b-button', {
    attrs: {
      "variant": "outline-primary",
      "size": "sm"
    },
    on: {
      "click": _vm.addRow
    }
  }, [_c('i', {
    staticClass: "fas fa-plus"
  }), _vm._v(" Add New Row ")])] : [_c('b-button', {
    attrs: {
      "variant": "primary",
      "size": "sm"
    },
    on: {
      "click": _vm.onSaveUpdate
    }
  }, [_c('i', {
    staticClass: "fa fa-floppy-o"
  }), _vm._v(" Save Update ")]), _c('b-button', {
    staticClass: "ml-2",
    attrs: {
      "variant": "outline-secondary",
      "size": "sm"
    },
    on: {
      "click": _vm.cancelUpdate
    }
  }, [_vm._v(" Cancel Update ")])]], 2), _c('table', {
    staticClass: "table align-middle"
  }, [_c('thead', {
    staticClass: "thead-light"
  }, [_c('tr', [!_vm.isDetail ? _c('th', {
    staticClass: "text-center",
    staticStyle: {
      "width": "48px"
    }
  }, [_c('b-form-checkbox', {
    attrs: {
      "disabled": !_vm.form.documents.length,
      "checked": _vm.rowIndexSelecteds.length === _vm.form.documents.length
    },
    on: {
      "input": _vm.toggleAll
    }
  })], 1) : _vm._e(), _vm.isDetail ? _c('th', {
    staticClass: "text-center align-middle",
    staticStyle: {
      "width": "48px"
    }
  }, [_c('i', {
    staticClass: "fa",
    class: _vm.allRowsEditing ? 'fa-trash-alt text-danger' : 'fa-edit text-primary',
    attrs: {
      "title": _vm.allRowsEditing ? 'Delete All Rows' : 'Edit Semua Baris'
    },
    on: {
      "click": function click($event) {
        _vm.allRowsEditing ? _vm.deleteAll() : _vm.toggleAllRowsEdit();
      }
    }
  })]) : _vm._e(), _c('th', [_vm._v("Action")]), _c('th', [_vm._v("Document Name")]), _c('th', [_vm._v("Shipment Plan Detail Number")]), _c('th', [_vm._v("Document Upload")]), !_vm.isDetail ? _c('th', {
    staticStyle: {
      "width": "40px"
    }
  }) : _vm._e()])]), _c('tbody', [(_vm$form$documents = _vm.form.documents) !== null && _vm$form$documents !== void 0 && _vm$form$documents.length ? _vm._l(_vm.form.documents, function (doc, index) {
    return _c('tr', {
      key: index
    }, [!_vm.isDetail ? _c('td', {
      staticClass: "text-center",
      staticStyle: {
        "width": "48px"
      },
      attrs: {
        "valign": "center"
      }
    }, [_c('b-form-checkbox', {
      attrs: {
        "value": index
      },
      model: {
        value: _vm.rowIndexSelecteds,
        callback: function callback($$v) {
          _vm.rowIndexSelecteds = $$v;
        },
        expression: "rowIndexSelecteds"
      }
    })], 1) : _vm._e(), !_vm.isDetail ? _c('td', {
      staticClass: "text-center",
      staticStyle: {
        "width": "48px"
      }
    }, [_c('b-button', {
      staticClass: "text-danger p-0",
      attrs: {
        "variant": "link",
        "size": "sm"
      },
      on: {
        "click": function click($event) {
          return _vm.deleteRow(index);
        }
      }
    }, [_c('i', {
      staticClass: "fas fa-trash-alt"
    })])], 1) : _vm._e(), _vm.isDetail ? _c('td', {
      staticClass: "text-center align-center",
      staticStyle: {
        "width": "48px"
      }
    }, [_c('i', {
      staticClass: "fa",
      class: _vm.isRowEditing(index) ? 'fa-trash-alt text-danger' : 'fa-edit text-primary',
      attrs: {
        "title": _vm.isRowEditing(index) ? 'Delete Row' : 'Edit Row'
      },
      on: {
        "click": function click($event) {
          _vm.isRowEditing(index) ? _vm.deleteRow(index) : _vm.startRowEdit(index);
        }
      }
    })]) : _vm._e(), _c('td', {
      staticStyle: {
        "width": "34%"
      },
      attrs: {
        "valign": "center"
      }
    }, [!_vm.isDetail ? [_c('b-form-input', {
      attrs: {
        "size": "sm"
      },
      model: {
        value: doc.fileName,
        callback: function callback($$v) {
          _vm.$set(doc, "fileName", $$v);
        },
        expression: "doc.fileName"
      }
    })] : [_vm.isRowEditing(index) ? [_c('b-form-input', {
      attrs: {
        "size": "sm"
      },
      model: {
        value: doc.fileName,
        callback: function callback($$v) {
          _vm.$set(doc, "fileName", $$v);
        },
        expression: "doc.fileName"
      }
    })] : [_c('span', {
      staticClass: "form-control-plaintext"
    }, [_vm._v(" " + _vm._s(doc.fileName || '-') + " ")])]]], 2), _c('td', {
      staticStyle: {
        "width": "34%"
      },
      attrs: {
        "valign": "center"
      }
    }, [!_vm.isDetail ? [_c('b-form-select', {
      staticClass: "bg-white",
      attrs: {
        "options": _vm.shipmentNumberOptions,
        "size": "sm",
        "plain": ""
      },
      scopedSlots: _vm._u([{
        key: "first",
        fn: function fn() {
          return [_c('option', {
            attrs: {
              "disabled": ""
            },
            domProps: {
              "value": null
            }
          }, [_vm._v(" Select Shipment Plan Detail Number ")])];
        },
        proxy: true
      }], null, true),
      model: {
        value: doc.shipmentPlanDetailNumber,
        callback: function callback($$v) {
          _vm.$set(doc, "shipmentPlanDetailNumber", $$v);
        },
        expression: "doc.shipmentPlanDetailNumber"
      }
    })] : [_vm.isRowEditing(index) ? [_c('b-form-select', {
      staticClass: "bg-white",
      attrs: {
        "options": _vm.shipmentNumberOptions,
        "size": "sm",
        "plain": ""
      },
      scopedSlots: _vm._u([{
        key: "first",
        fn: function fn() {
          return [_c('option', {
            attrs: {
              "disabled": ""
            },
            domProps: {
              "value": null
            }
          }, [_vm._v(" Select Shipment Plan Detail Number ")])];
        },
        proxy: true
      }], null, true),
      model: {
        value: doc.shipmentPlanDetailNumber,
        callback: function callback($$v) {
          _vm.$set(doc, "shipmentPlanDetailNumber", $$v);
        },
        expression: "doc.shipmentPlanDetailNumber"
      }
    })] : [_c('span', {
      staticClass: "form-control-plaintext"
    }, [_vm._v(" " + _vm._s(doc.shipmentPlanDetailNumber || '-') + " ")])]]], 2), _c('td', {
      staticStyle: {
        "width": "34%"
      },
      attrs: {
        "valign": "center"
      }
    }, [!_vm.isDetail ? [_c('div', {
      staticClass: "d-flex flex-column"
    }, [_c('b-form-file', {
      attrs: {
        "size": "sm",
        "browse-text": "Browse",
        "placeholder": "Choose file..."
      },
      model: {
        value: doc.file,
        callback: function callback($$v) {
          _vm.$set(doc, "file", $$v);
        },
        expression: "doc.file"
      }
    }), _vm._m(0, true)], 1)] : [_vm.isRowEditing(index) ? [_c('div', {
      staticClass: "d-flex flex-column"
    }, [_c('b-form-file', {
      attrs: {
        "size": "sm",
        "browse-text": "Browse",
        "placeholder": "Choose file..."
      },
      model: {
        value: doc.file,
        callback: function callback($$v) {
          _vm.$set(doc, "file", $$v);
        },
        expression: "doc.file"
      }
    }), _vm._m(1, true)], 1)] : [doc.fileUrl ? _c('button', {
      staticClass: "btn btn-link p-0 form-control-plaintext text-left",
      attrs: {
        "type": "button"
      },
      on: {
        "click": function click($event) {
          return _vm.openDocument(doc);
        }
      }
    }, [_vm._v(" " + _vm._s(doc.fileName) + "." + _vm._s(doc.extension) + " ")]) : _vm._e()]]], 2)]);
  }) : [_vm._m(2)]], 2)])]);

}
var staticRenderFns = [function (){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('small', [_vm._v(" File Type : "), _c('b', [_vm._v(".Pdf")])]), _c('span', {
    staticClass: "mx-2"
  }, [_vm._v("|")]), _c('small', [_vm._v(" Max File Size : "), _c('b', [_vm._v("25 MB")])])]);
} /* staticRenderFnsSpliter */, function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('small', [_vm._v(" File Type : "), _c('b', [_vm._v(".Pdf")])]), _c('span', {
    staticClass: "mx-2"
  }, [_vm._v("|")]), _c('small', [_vm._v(" Max File Size : "), _c('b', [_vm._v("25 MB")])])]);
} /* staticRenderFnsSpliter */, function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('tr', [_c('td', {
    attrs: {
      "colspan": "3"
    }
  }, [_vm._v("No Documnet Needed!")])]);

}]

export { render, staticRenderFns }